/*
 * @Author: 彭鑫诚
 * @Date: 2024-06-06 11:06:02
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-06-13 10:09:05
 * @Description: file content
 */
import type {
  IStockTransferModel,
  IStockTransferStore,
} from '@monorepo/types/check/stockTransfer/stockTransfer.types';
import { getSevenDays } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IStockTransferStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    date: getSevenDays(),
    sort_order: 'CREATED_DESC',
    filter_anti_about: false,
  },
  auditNo: '',
  cachePath: '/',
};

const stockTransferModel: IStockTransferModel = {
  namespace: 'stockTransferStore',
  state: { ...initState },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
    resetInit() {
      return { ...initState };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
  },
};

export { initState };

export default stockTransferModel;
